module.exports = __webpack_public_path__ + "img/banner_research.b5bc7247.png";